export default __webpack_public_path__ + "static/HaierService-0c7c24c84be3f18765c138bc42b3d287.jpg";